
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

import { ObjectType, SportType } from '@/@types/graphql-types';
import { SnowplowSportContext } from '@/helpers/tracking/providers';
import { TrackingHelper } from '@/helpers/tracking/tracking-helper';
import type { BreadcrumbItem } from '@/interfaces/sport-graphql';

@Component({ name: 'Breadcrumbs' })
export default class Breadcrumbs extends Vue {
	@Prop({ default: () => [] }) items: BreadcrumbItem[];

	routerParams(item: BreadcrumbItem) {
		if (item.routeName) {
			return { name: item.routeName, params: item.routeParams };
		}

		if (item.url) {
			return { path: item.url, params: item.routeParams };
		}
	}

	handleLinkClick(item: BreadcrumbItem, index: number) {
		// don't handle link click when it's the last item, and thus active item, in the list
		if (index + 1 === this.items.length) return;

		const contexts = this.getContextsFromBreadcrumbItem(item);
		TrackingHelper.trackEvent(
			'userinteraction',
			{
				action: 'breadcrumb_menu_click',
				useLastRoute: true,
			},
			contexts
		);
	}

	private getContextsFromBreadcrumbItem(item: BreadcrumbItem) {
		if (item.objectType) {
			const sportType = this.$route.meta?.sport as SportType;
			const sportContext = new SnowplowSportContext(sportType, item.objectType);
			// check for competition objectId
			if (item.objectId && item.objectType === ObjectType.SportCompetition) {
				sportContext.competitionId = item.objectId;
			}
			return [sportContext];
		}
		return undefined;
	}
}
